import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  dismissLabel: {
    id: 'authoring.alert-error-alert.dismiss',
    defaultMessage: 'Dismiss',
    description: 'The label for the dismiss button on the alert error component.',
  },
});

export default messages;
